import { Components, ThisGorillaUtils } from "@thisgorilla/primate-ds";
import styled, { useTheme } from "styled-components";
import { FlexColumn, FlexRow } from "../Styles";
import { useAppSelector } from "../../../redux";

const AnonymousUserToolTip = () => {
  const { Color, typography } = useTheme();
  const { anonymous_persona } = useAppSelector((state) => state.me);
  return (
    <Container>
      <Components.Text
        text={"Posting as"}
        style={{ tokenStyle: typography.Body.S }}
        color={Color.text["text-emphasize-brand-bolder"].value}
        lineHeight="line-height-75"
        fontWeight="font-weight-semibold"
      />
      <FlexColumn $gapInPx={0}>
        <Components.Text
          text={anonymous_persona}
          style={{ tokenStyle: typography.Heading.XXS }}
          fontWeight="font-weight-bold"
        />
        <Components.Text
          text={"Cape Town"}
          style={{ tokenStyle: typography.Body.S }}
          fontWeight="font-weight-semibold"
          color={Color.text["text-tertiary"].value}
          lineHeight="line-height-50"
        />
      </FlexColumn>
      <Wrapper>
        <Components.Icon
          type="Info"
          size="16px"
          color={Color.icon["icon-brand-bolder"].value}
        />
        <Components.Text
          text="Lorem ipsum dolor sit amet consectetur. Eleifend ut eu tincidunt odio a ipsum id. Gravida neque pretium dolor tempor malesuada phasellus at. Proin sapien lectus nisl sed."
          style={{ tokenStyle: typography.Body.M }}
          color={Color.text["text-emphasize-brand-bolder"].value}
        />
      </Wrapper>
    </Container>
  );
};

export default AnonymousUserToolTip;

const Container = styled(FlexColumn)`
  max-width: ${ThisGorillaUtils.convertPxToRem("330")}rem;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  margin: ${({ theme }) => theme.spacing["spacing-none"].value}rem
    ${({ theme }) => -theme.spacing["spacing-2"].value}rem;
  background: linear-gradient(
    116deg,
    #f4fbff 21.57%,
    rgba(230, 236, 255, 0) 76.26%
  );
`;

const Wrapper = styled(FlexRow)`
  padding: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  background: ${({ theme }) =>
    theme.Color.background.brand.subtlest["default-hover"].value};
`;
